import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import { fromEntities } from '../../store/selectors';
import ForecastAdjustments from '../../components/molecules/ForecastAdjustments/index';
import { createValidator, minSize, required } from '../../services/validation';

const ForecastContainer = props => <ForecastAdjustments {...props} />;

const mapStateToProps = (
  state,
  {
    match: {
      params: { forecastId, revisionId },
    },
  }
) => {
  const forecastMain = fromEntities.getDetail(state, 'forecast', forecastId) || {};
  const revision = fromEntities.getDetail(state, 'forecastRevision', revisionId) || {};

  const {
    inpath_pct_of_requests,
    inhand_product_count,
    avg_ad_request_per_device,
    ease_of_scan,
  } = {
    ...forecastMain,
    ...revision,
  };

  return {
    initialValues: {
      inhand_product_count,
      avg_ad_request_per_device,
      // Multiply it as all percentages in forecast
      inpath_pct_of_requests: inpath_pct_of_requests * 100,
      ease_of_scan: ease_of_scan * 100,
    },
  };
};

const mapDispatchToProps = () => ({});

const validate = createValidator({
  inhand_product_count: [required, minSize(1)],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    validate,
    form: 'ForecastAdjustments',
    enableReinitialize: true,
  })
)(ForecastContainer);
